import * as React from "react";
import { useGameContext } from "src/game/useGameContext";
import {
  GameSummaryEmpty,
  GameSummaryTaskListHeader,
  GameSummaryTaskListItem,
  GameSummaryTaskListWrapper,
  TaskListHeaderCell,
  TaskListItemCell,
} from "./GameSummaryTaskList.components";

const GameSummaryTaskList: React.FunctionComponent = () => {
  const { gameState } = useGameContext();

  if (
    !gameState.game ||
    !gameState.game.allTasks ||
    gameState.game.allTasks?.length === 0
  ) {
    return <GameSummaryEmpty>No tasks were voted</GameSummaryEmpty>;
  }

  return (
    <>
      <GameSummaryTaskListHeader>
        <TaskListHeaderCell>Task Name</TaskListHeaderCell>
        <TaskListHeaderCell>Average</TaskListHeaderCell>
        <TaskListHeaderCell>Agreement</TaskListHeaderCell>
        <TaskListHeaderCell>Final result</TaskListHeaderCell>
      </GameSummaryTaskListHeader>
      <GameSummaryTaskListWrapper>
        {gameState.game.allTasks?.map(task => (
          <GameSummaryTaskListItem key={task.id}>
            <TaskListItemCell>{task.description}</TaskListItemCell>
            <TaskListItemCell>{task.summary?.avgScore ?? "-"}</TaskListItemCell>
            <TaskListItemCell>
              {task.summary?.agreementScore
                ? `${task.summary?.agreementScore}%`
                : "-"}
            </TaskListItemCell>
            <TaskListItemCell>
              {task.summary?.finalResult ?? "-"}
            </TaskListItemCell>
          </GameSummaryTaskListItem>
        ))}
      </GameSummaryTaskListWrapper>
    </>
  );
};

export default GameSummaryTaskList;
